<template>
    <div>
        <p class="text-guide">
            {{ $t('paragraphs.channel.country_restriction_tip_1')}}<br>
            {{ $t('paragraphs.channel.country_restriction_tip_2')}}
        </p>
        <form method="post">
            <div class="row">
                <div class="col-md-6">
                    <div v-if="haveSubmitRight" class="form-group blocked_country">
                        <label for="block_countries">{{ $t('words.blocked_country')}}</label>
                        <select id="block_countries" :placeholder="$t('words.blocked_country_select')">
                        </select>
                    </div>
                    <ul class="blocked_country__list">
                        <li v-if="blocks.length > 0" v-for="country in blocks" :key="country.country_code">
                            {{ findCountryName(country) }} <button class="btn btn btn-icon btn-danger" v-if="haveSubmitRight" @click.prevent="doRemoveBlocks(country)"><i class="icon icon-close"></i></button>
                        </li>
                    </ul>
                </div>
                <div class="col-md-6">
                   <div v-if="haveSubmitRight" class="form-group allowed_country">
                        <label for="allow_countries">{{ $t('words.allowed_country')}}</label>
                        <select id="allow_countries" :placeholder="$t('words.allowed_country_select')">
                        </select>
                   </div>
                    <ul class="allowed_country__list">
                        <li v-if="allows.length > 0" v-for="country in allows" :key="country.country_code">
                            {{ findCountryName(country) }} <button class="btn btn-icon btn-danger" v-if="haveSubmitRight" @click.prevent="doRemoveAllows(country)"><i class="icon icon-close"></i></button>
                        </li>
                    </ul>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    props: {
        channel: {
            type: [Object],
            require: true,
        },
        modifyMode: {
            type: [Boolean],
            require: true,
        },
        currentTab: {
            type: [String],
            require: true,
        },
    },
    data() {
        return {
            tab_name: 'country_restriction',
            allows: [],
            blocks: [],
            countries: [],
            allow: '',
            block: '',
            meta: {
                errors: {},
            },
        };
    },
    mounted() {
    },
    methods: {
        initialize() {
            this.getCountries();
            this.getDatas();
        },
        getDatas() {
            axios.get(this.countryRestrictionApi).then((response) => {
                this.allows = response.data.allows;
                this.blocks = response.data.blocks;
            }).catch((error) => {
                this.meta.errors = error.response.data.errors;
            });
        },
        renderSelectize() {
            const self = this;
            $('#block_countries').selectize({
                valueField: 'code',
                labelField: 'name',
                searchField: 'name',
                preload: true,
                create: false,
                maxItems: 1,
                onChange(value) {
                    if (value === '') {
                        return;
                    }
                    self.block = value;
                    self.doAppendBlocks();
                },
                load(query, callback) {
                    this.clearOptions();
                    const blockCountries = self.countries;
                    blockCountries.splice(0, 0, { code: '', name: self.$t('words.blocked_country_select') });
                    callback(blockCountries);
                },
            });
            $('#allow_countries').selectize({
                valueField: 'code',
                labelField: 'name',
                searchField: 'name',
                preload: true,
                create: false,
                maxItems: 1,
                onChange(value) {
                    if (value === '') {
                        return;
                    }
                    self.allow = value;
                    self.doAppendAllows();
                },
                load(query, callback) {
                    this.clearOptions();
                    const allowCountries = self.countries;
                    allowCountries.splice(0, 0, { code: '', name: self.$t('words.allowed_country_select') });
                    callback(allowCountries);
                },
            });
        },
        getCountries() {
            const self = this;
            axios.get(`/cms/${this.selectedServiceAccount.key}/countries`).then((response) => {
                self.countries = response.data.countries;
                self.renderSelectize();
            }).catch((error) => {
                self.meta.errors = error.response.data.errors;
            });
        },
        findCountryName(country) {
            const search = _.find(this.countries, item => item.code === country.country_code);
            return search.name;
        },
        isInBlocks(country) {
            const search = _.find(this.blocks, item => country === item.country_code);
            return (typeof search !== 'undefined');
        },
        isInAllows(country) {
            const search = _.find(this.allows, item => country === item.country_code);
            return (typeof search !== 'undefined');
        },
        doAppendBlocks() {
            if (!this.haveSubmitRight) {
                return;
            }

            const country = this.block;
            if (country.length === 0) {
                this.$toasted.error(this.$t('paragraphs.message.error.empty_country'));
                return;
            }
            if (this.isInBlocks(country)) {
                this.$toasted.error(this.$t('paragraphs.message.error.exist_in_blocks'));
                return;
            }
            if (this.isInAllows(country)) {
                this.$toasted.error(this.$t('paragraphs.message.error.exist_in_allows'));
                return;
            }
            axios.post(this.countryRestrictionApi, { kind: 'block', country_code: country }).then((response) => {
                this.allows = response.data.allows;
                this.blocks = response.data.blocks;

                this.$toasted.success(this.$t('paragraphs.message.success.store'));
            }).catch((error) => {
                this.$toasted.error(this.$t('paragraphs.message.error.change'));
            });
        },
        doAppendAllows() {
            if (!this.haveSubmitRight) {
                return;
            }

            const country = this.allow;
            if (country.length === 0) {
                this.$toasted.error(this.$t('paragraphs.message.error.empty_country'));
                return;
            }
            if (this.isInBlocks(country)) {
                this.$toasted.error(this.$t('paragraphs.message.error.exist_in_blocks'));
                return;
            }
            if (this.isInAllows(country)) {
                this.$toasted.error(this.$t('paragraphs.message.error.exist_in_allows'));
                return;
            }
            axios.post(this.countryRestrictionApi, { kind: 'allow', country_code: country }).then((response) => {
                this.allows = response.data.allows;
                this.blocks = response.data.blocks;

                this.$toasted.success(this.$t('paragraphs.message.success.store'));
            }).catch((error) => {
                this.$toasted.error(this.$t('paragraphs.message.error.change'));
            });
        },
        doRemoveBlocks(country) {
            if (!this.haveSubmitRight) {
                return;
            }

            if (confirm(this.$t('paragraphs.message.confirm.remove_item'))) {
                const self = this;
                axios.delete(`${this.countryRestrictionApi}/remove`, { data: { kind: 'block', country_code: country.country_code } }).then((response) => {
                    this.getDatas();
                    self.$toasted.success(this.$t('paragraphs.message.success.remove'));
                }).catch((error) => {
                    self.creators.meta.errors = error.response.data.errors;
                    self.$toasted.error(this.$t('paragraphs.message.error.remove_country'));
                });
            }
        },
        doRemoveAllows(country) {
            if (!this.haveSubmitRight) {
                return;
            }

            if (confirm(this.$t('paragraphs.message.confirm.remove_item'))) {
                const self = this;
                axios.delete(`${this.countryRestrictionApi}/remove`, { data: { kind: 'allow', country_code: country.country_code } }).then((response) => {
                    this.getDatas();
                    self.$toasted.success(this.$t('paragraphs.message.success.remove'));
                }).catch((error) => {
                    self.creators.meta.errors = error.response.data.errors;
                    self.$toasted.error(this.$t('paragraphs.message.error.remove_country'));
                });
            }
        },
    },
    computed: {
        countryRestrictionApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.channel.id}/country_restrictions`;
        },
        haveSubmitRight() {
            return (!this.modifyMode && this.haveOwnerRight) || (this.modifyMode && this.haveManagerRight);
        },
        loadedChannel() {
            return this.loadedServiceAccount && ('id' in this.channel) && (this.channel.id !== '');
        },
        selectedTab() {
            return this.loadedChannel && this.currentTab === this.tab_name;
        },
    },
    watch: {
        selectedTab(newValue) {
            if (newValue) {
                this.initialize();
            }
        },
    },
};

</script>
